Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomCreator extends Backbone.View
  template: JST["backbone/templates/monitoring/charts/custom_creator"]
  events:
    'click #add': 'addChart'
    'change #chart_type': 'chartChange'
    'change #dimension': 'dimensionChange'
    'change #cross_dimension': 'setTitle'
    'click #dimension': 'saveSelectedDimension'

  initialize: (@customFields, @dimensionsList, @mappedDimensions, @taxonomiesCodes) ->

  render: () ->
    sorted_dimensions = _.sortBy(@dimensionsList, (dimension) -> I18n.t("monitoring.dashboard.charts.#{dimension}"))
    @$el.html(@template(dimensions: sorted_dimensions, custom_fields: @customFields, mapped_dimensions: @mappedDimensions, taxonomies_codes: @taxonomiesCodes, truncate: @truncate))
    @setTitle()
    @disableDuplicatedDimension()
    @saveSelectedDimension()

  show: () ->
    @$el.find("#custom_chart_creator").modal()
    setTimeout =>
      @previewChart()
    , 500

  truncate: (text, maxLength = 50) ->
    if text.length > maxLength
      text.slice(0, maxLength) + "..."
    else
      text

  addChart: () =>
    chartClass = @$el.find('#chart_type option:selected').data('class')
    chartType = @$el.find('#chart_type option:selected').data('type')
    chartDimension = @$el.find('#dimension option:selected').val()
    chartTitle = @$el.find('#title').val()
    chartStacking = @$el.find('#chart_type option:selected').data('stacking')
    if @$el.find('#chart_type option:selected').data('class') == 'HierarchyNavigationHeatmapChartView'
      crossDimension = 'tags'
      hierarchyCode = @$el.find('#hierarchy_select option:selected').val()
    else
      crossDimension = @$el.find('#cross_dimension option:selected').val()
      hierarchyCode = undefined
    settings = {
      class: chartClass
      type: chartType
      dimension: chartDimension
      title: chartTitle
      stacking: chartStacking
      crossDimension: crossDimension
      hierarchyCode: hierarchyCode
      special: @$el.find('#chart_type option:selected').data('special')
    }

    if @$el.find('#chart_type option:selected').data('class') == "CustomCrossDimensionsChart"
      settings['chartDimensionTitle'] = @$el.find('#dimension option:selected').text()
      settings['crossDimensionTitle'] = @$el.find('#cross_dimension option:selected').text()

    @$el.find('#custom_chart_creator').modal('hide')
    @trigger('addChart', settings)

  chartChange: () =>
    chartType = @$el.find('#chart_type option:selected').data('class')
    special = @$el.find('#chart_type option:selected').data('special')

    if chartType == 'CustomCrossDimensionsChart' || special == 'nps'
      if @$el.find('#dimension option[value="time"]').length == 0
        @$el.find('#dimension').append($('<option>', {
          value: 'time'
          text: I18n.t("monitoring.dashboard.charts.time").titleize()
        }))
    else
      @$el.find('#dimension option[value="time"]').remove()

    if special == 'nps'
      @disableOptionByValue(@$el.find('#dimension'), 'nps')
    else
      @enableOptionByValue(@$el.find('#dimension'), 'nps')

    needsSecondDimension = chartType in ['CustomCrossDimensionsChart', 'CustomHeatmapChart']
    if needsSecondDimension
      @$el.find('.cross_dimension').removeClass('disabled')
      @$el.find('#cross_dimension').prop('disabled', false)
    else
      @$el.find('.cross_dimension').addClass('disabled')
      @$el.find('#cross_dimension').prop('disabled', 'disabled')
    heatMap = @$el.find('#chart_type option:selected').data('class') == 'HierarchyNavigationHeatmapChartView'
    if heatMap
      @$el.find('#cross_dimension').addClass("d-none")
      @$el.find('.cross_dimension').addClass("d-none")
      @$el.find('.hierarchy_select').removeClass("d-none")
    else
      @$el.find('#cross_dimension').removeClass("d-none")
      @$el.find('.cross_dimension').removeClass("d-none")
      @$el.find('.hierarchy_select').addClass("d-none")

    @setTitle()
    @previewChart()

  disableOptionByValue: (select, valueToDisable) ->
    $select = $(select)
    $option = $select.find("option[value='#{valueToDisable}']")

    return unless $option.length

    # If the option is currently selected, change selection first
    if $option.is(':selected')
      $fallback = $select.find('option:not(:disabled)').not($option).first()
      $select.val($fallback.val()) if $fallback.length

    # Disable the option
    $option.prop('disabled', true)

  enableOptionByValue: (select, valueToEnable) ->
    $select = $(select)
    $option = $select.find("option[value='#{valueToEnable}']")

    return unless $option.length

    $option.prop('disabled', false)

  disableDuplicatedDimension: () ->
    @$el.find('#cross_dimension option').eq(0).attr('disabled', true)
    @$el.find('#cross_dimension option').eq(1).attr('selected', true);

  saveSelectedDimension: () ->
    @previouslySelectedDimension = @$el.find('#dimension option:selected').attr('value')

  dimensionChange: () ->
    @updateAvailableCrossDimensions()
    @setTitle()

  updateAvailableCrossDimensions: () ->
    @$el.find('#cross_dimension option[disabled="disabled"]').attr('disabled', false)
    selectedDimension = @$el.find('#dimension option:selected').attr('value')
    selectedCrossDimension = @$el.find('#cross_dimension option:selected').attr('value')
    @$el.find('#cross_dimension option[value="' + selectedDimension + '"]').attr('disabled', true)
    if selectedDimension == selectedCrossDimension
      @$el.find('#cross_dimension').val(@previouslySelectedDimension)


  setTitle: () ->
    classSelected = @$el.find('#chart_type option:selected').data('class')
    dimension = @$el.find('#dimension option:selected').attr('title') || @$el.find('#dimension option:selected').text()
    special = @$el.find('#chart_type option:selected').data('special')
    if (classSelected in ['CustomCrossDimensionsChart', 'CustomHeatmapChart'])
      crossDimension = @$el.find('#cross_dimension option:selected').attr('title') || @$el.find('#cross_dimension option:selected').text()
      @$el.find("#title").val("#{dimension} #{I18n.t('monitoring.dashboard.charts.by')} #{crossDimension}")
    else if special == 'nps'
      @$el.find("#title").val("NPS #{I18n.t('monitoring.dashboard.charts.by')} #{dimension}")
    else
      @$el.find("#title").val(dimension)

  previewChart: () ->
    type_selected = @$el.find('#chart_type option:selected').data('preview')
    stacking = @$el.find('#chart_type option:selected').data('stacking')
    chartOptions = new Common.Dashboard.PreviewChartOptions().chartOptions(type_selected, stacking)
    @chart = new Highcharts.Chart($.extend(true, chartOptions, @_chartOptions()))

  _chartOptions: ->
    chart:
      renderTo: @$el.find('.chart')[0]
      height: 235
